export const SET_MAKE_AI_SEARCH_SUCCESS = 'SET_MAKE_AI_SEARCH_SUCCESS';
export const SET_SELECTED_BULLET_ID = 'SET_SELECTED_BULLET_ID';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';
